<template>
    <div v-if="event" class="event-grid-item" aria-label="event">
        <router-link
            class="text-decoration-none"
            :to="`/events/detail/${event.sys.id}`"
        >
            <v-col class="pa-0">
                <div class="image">
                    <v-img
                        :src="event.file.url"
                        :alt="event.file.fileName || 'Event Thumbnail'"
                        height="226px"
                        width="380px"
                    />
                    <div
                        v-if="!isPast"
                        class="date d-flex flex-column justify-center align-center"
                        :class="[
                            color,
                            color === 'accent' ? 'white--text' : 'black--text'
                        ]"
                    >
                        <strong>{{
                            event.fields.date | formatDate('DD')
                        }}</strong>
                        <span style="font-size: 16px">{{
                            event.fields.date | formatDate('MMM')
                        }}</span>
                    </div>
                    <div class="mt-3">
                        <strong
                            v-if="!isPast && event.fields.tags"
                            class="primary--text"
                        >
                            <span
                                v-for="(tag, i) of event.fields.tags"
                                :key="'event-tag-' + tag + '_' + i"
                                class="font-small"
                            >
                                {{ tag | uppercase }}
                                {{
                                    event.fields.tags.length > i + 1
                                        ? ' + '
                                        : ''
                                }}
                            </span>
                        </strong>
                        <strong v-else class="primary--text">
                            <span class="font-small">Recorded Event</span>
                        </strong>
                    </div>
                </div>
                <section class="content d-flex flex-column">
                    <h3 class="secondary--text mt-3 h4">
                        {{ event.fields.name }}
                    </h3>
                    <ctf-rich-text
                        class="mt-3"
                        style="margin-bottom: -10px"
                        :document="event.fields.description"
                    />
                    <strong
                        role="button"
                        class="primary--text hover-icon-right"
                    >
                        {{ event.fields.linkText || 'Register' }}
                        <v-icon
                            :color="color === 'error' ? 'gold' : 'accent'"
                            postfix
                        >
                            arrow_forward
                        </v-icon>
                    </strong>
                </section>
            </v-col>
        </router-link>
    </div>
</template>

<script>
export default {
  name: 'EventGroupItem',
  props: {
    event: {
      type: Object,
      required: true
    },
    isPast: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'accent'
    }
  }
}
</script>

<style lang="scss" scoped>
.event-grid-item {
    max-width: 380px;
    margin: 0 auto;
}

.image {
    position: relative;
    max-width: 100%;
    .date {
        position: absolute;
        top: 15px;
        left: 15px;
        width: 66px;
        height: 66px;
        font-size: 24px;
        line-height: 22px;
        border-radius: 100%;
    }
}
</style>
